import { render, staticRenderFns } from "./PdTabSettingModalForm.vue?vue&type=template&id=de5431dc&scoped=true&"
import script from "./PdTabSettingModalForm.vue?vue&type=script&lang=ts&"
export * from "./PdTabSettingModalForm.vue?vue&type=script&lang=ts&"
import style0 from "./PdTabSettingModalForm.vue?vue&type=style&index=0&id=de5431dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5431dc",
  null
  
)

export default component.exports